import { Button, CardActions, CardContent, Modal, Typography } from '@mui/material';
import ArrowBackIosNewTwoToneIcon from '@mui/icons-material/ArrowBackIosNewTwoTone';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CircularProgress from '@mui/material/CircularProgress';
import StraightenIcon from '@mui/icons-material/Straighten';
import { ConfirmCard } from './Styles';

interface TravelDistanceWarningModalProps {
    open: boolean;
    onClose: () => void;
    onMove: () => void;
    loading: boolean;
    handleTravelDistanceCalculate: () => Promise<void>;
}

export default function TravelDistanceWarningModal({ open, onClose, onMove, loading, handleTravelDistanceCalculate }: TravelDistanceWarningModalProps) {
    return (
        <Modal open={open} onClose={onClose}>
            <ConfirmCard sx={{ minWidth: 500 }}>
                <CardContent sx={{ p: 2 }}>
                    <Typography variant={'h6'} pb={3}>
                        Hiányzó távolság adatok
                    </Typography>
                    <Typography paragraph>
                        A terv nem minden járatán van a megtett távolság kiszámítva.
                        <br />
                        Kérjük, hogy először számítsa ki a távolságot.
                    </Typography>
                </CardContent>
                <CardActions sx={{ justifyContent: 'space-between' }}>
                    <Button
                        sx={{ mx: 1, borderRadius: 50 }}
                        variant={'contained'}
                        size={'small'}
                        color={'info'}
                        onClick={() => onClose()}
                        startIcon={<ArrowBackIosNewTwoToneIcon />}>
                        Bezárás
                    </Button>
                    <Button
                        variant='contained'
                        size={'small'}
                        sx={{ borderRadius: 50, marginRight: 0.25 }}
                        onClick={() => handleTravelDistanceCalculate()}
                        endIcon={loading ? <CircularProgress size={20} color='inherit' /> : <StraightenIcon />}>
                        Távolság kiszámítása
                    </Button>
                    <Button
                        variant='contained'
                        size={'small'}
                        sx={{ borderRadius: 50, marginRight: 0.25 }}
                        onClick={() => onMove()}
                        endIcon={<ArrowForwardIosIcon />}>
                        Tovább
                    </Button>
                </CardActions>
            </ConfirmCard>
        </Modal>
    );
}
